import React, { Fragment, ReactElement, ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Box, Breadcrumbs, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const PageTitleContainer = () => {
  return (
    <Stack gap={1} mb={1} sx={{ flexShrink: 0 }}>
      <Box id="page-breadcrumbs" sx={{ "&:empty": { display: "none" } }}></Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack gap={1}>
          <Box id="page-title"></Box>
          <Box id="page-subtitle" sx={{ "&:empty": { display: "none" } }}></Box>
        </Stack>
        <Box id="page-actions" sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}></Box>
      </Stack>
    </Stack>
  );
};

export const PageTitle = ({ children }: { children: ReactNode }) => {
  const [rendered, setRendered] = useState(false);
  useEffect(() => {
    setRendered(true);
  }, []);
  if (!rendered) return null;
  return createPortal(
    <Typography variant="h5" component="h1" sx={{ marginBottom: 0 }}>
      {children}
    </Typography>,
    document.getElementById("page-title") as HTMLElement,
  );
};

export const PageActions = ({ children }: { children: ReactNode }) => {
  const [rendered, setRendered] = useState(false);
  useEffect(() => {
    setRendered(true);
  }, []);
  if (!rendered) return null;
  return createPortal(children, document.getElementById("page-actions") as HTMLElement);
};

export interface BreadcrumbLink {
  label: string;
  path?: string;
  icon?: ReactElement;
}

export const PageBreadcrumbs = ({ links }: { links: BreadcrumbLink[] }) => {
  const [rendered, setRendered] = useState(false);
  useEffect(() => {
    setRendered(true);
  }, []);
  if (!rendered) return null;
  return createPortal(
    <Breadcrumbs>
      {links.map((link, index) => (
        <Fragment key={index}>
          {link.path && (
            <Link color="inherit" underline="hover" component={RouterLink} to={link.path}>
              {link.label}
            </Link>
          )}
          {!link.path && <Typography color="text.secondary">{link.label}</Typography>}
        </Fragment>
      ))}
    </Breadcrumbs>,
    document.getElementById("page-breadcrumbs") as HTMLElement,
  );
};

export const PageSubtitle = ({ children }: { children: ReactNode }) => {
  const [rendered, setRendered] = useState(false);
  useEffect(() => {
    setRendered(true);
  }, []);
  if (!rendered) return null;
  return createPortal(children, document.getElementById("page-subtitle") as HTMLElement);
};
